// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";
import posthog from 'posthog-js'

Sentry.init({
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
    dsn: "https://978cf55cf4f1e79dd0e9b5b9f39fdd90@o4508523317428224.ingest.us.sentry.io/4508523318935552",

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    integrations: [posthog.sentryIntegration({
        organization: 'rthm',
        projectId: 4508523318935552,
        severityAllowList: ['error', 'info'] // optional: here is set to handle captureMessage (info) and captureException (error)
    }
    )],
});
